<template>
    <div>
        <!-- start page title -->
        <div class="row">
            <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h4 class="mb-sm-0 font-size-18">Dashboard</h4>
                </div>
            </div>
        </div>
        <br><br>
        <div class="main-body">
            <div class="row grouped-multiple-statistics-card">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-6 col-xl-3 col-sm-6 col-12">
                                    <div
                                        class="d-flex align-items-start mb-sm-1 mb-xl-0 border-right-blue-grey border-right-lighten-5">
                                        <span class="card-icon primary d-flex justify-content-center mr-3"><i
                                            class="icon p-1 icon-bar-chart customize-icon font-large-2 p-1"></i></span>
                                        <div class="stats-amount mr-3"><h3 class="heading-text text-bold-600">
                                            ₦ {{ total_revenue }}</h3>
                                            <p class="sub-heading">Total Revenue</p></div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-xl-3 col-sm-6 col-12">
                                    <div
                                        class="d-flex align-items-start mb-sm-1 mb-xl-0 border-right-blue-grey border-right-lighten-5">
                                        <span class="card-icon danger d-flex justify-content-center mr-3"><i
                                            class="icon p-1 icon-users customize-icon font-large-2 p-1"></i></span>
                                        <div class="stats-amount mr-3"><h3 class="heading-text text-bold-600">
                                            {{ total_users }}
                                        </h3>
                                            <p class="sub-heading">Customers</p></div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-xl-3 col-sm-6 col-12">
                                    <div class="d-flex align-items-start border-right-blue-grey border-right-lighten-5">
                                        <span class="card-icon success d-flex justify-content-center mr-3"><i
                                            class="fa p-1 fa-building customize-icon font-large-2 p-1"></i></span>
                                        <div class="stats-amount mr-3"><h3 class="heading-text text-bold-600">
                                            {{ total_stores }}
                                        </h3>
                                            <p class="sub-heading">Restaurants</p></div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-xl-3 col-sm-6 col-12">
                                    <div class="d-flex align-items-start"><span
                                        class="card-icon warning d-flex justify-content-center mr-3"><i
                                        class="icon p-1 icon-basket-loaded customize-icon font-large-2 p-1"></i></span>
                                        <div class="stats-amount mr-3"><h3 class="heading-text text-bold-600">
                                            {{ total_orders }}
                                        </h3>
                                            <p class="sub-heading">Orders</p></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row match-height" v-if="!is_store_manager">
                <div class="col-xl-12 col-lg-12 col-md-12">
                    <div class="card">
                        <div class="card-header border-0"><h4 class="card-title">Stores With Low Inventory</h4></div>
                        <div class="card-content">
                            <div id="audience-list-scroll" class="table-responsive position-relative">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th>Store Name</th>
                                        <th>City</th>
                                        <th>State</th>
                                        <th>Unavailable Products Count</th>
                                        <th>Unavailable Products Percentage</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-for="store in stores_with_low_inventory">
                                        <tr>
                                            <td class="align-middle text-danger"><span>{{ store.name }}</span></td>
                                            <td class="align-middle text-danger"><span>{{ store.city.name }}</span></td>
                                            <td class="align-middle text-danger"><span>{{ store.state.name }}</span></td>
                                            <td class="text-center align-middle text-danger">
                                                {{ store.low_inventory_count }}
                                            </td>
                                            <td class="text-center align-middle text-danger">
                                                {{ Math.ceil(store.low_inventory_percentage) }}%
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="text-right mb-1 mr-1">
                            <a :href="url+'?sortby=low_inventory_count'">
                                View More
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row match-height" v-if="!is_store_manager">
                <div class="col-xl-12 col-lg-12 col-md-12">
                    <div class="card">
                        <div class="card-header border-0"><h4 class="card-title">Inactive Stores</h4></div>
                        <div class="card-content">
                            <div id="audience-list-scroll" class="table-responsive position-relative">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th>Store Name</th>
                                        <th>City</th>
                                        <th>State</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-for="store in inactive_stores">
                                        <tr>
                                            <td class="align-middle text-danger"><span>{{ store.name }}</span></td>
                                            <td class="align-middle text-danger"><span>{{ store.city.name }}</span></td>
                                            <td class="align-middle text-danger"><span>{{ store.state.name }}</span></td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="text-right mb-1 mr-1">
                            <a :href="url">
                                View More
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12 col-md-12">
                    <div class="card active-users">
                        <div class="card-header border-0"><h4 class="card-title">Orders</h4></div>
                        <div class="card-content">
                            <div id="audience-list-scroll" class="table-responsive position-relative">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th>Order number</th>
                                        <th>Payment method</th>
                                        <th>Order type</th>
                                        <th>Total</th>
                                        <th>Status</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-for="order in fetchedOrders">
                                        <tr>
                                            <td class="text-truncate"><span class="text-truncate"><a
                                                :href="route('admin.orders.show', order.id)">
                                                        {{ order.order_no }}
                                                    </a></span></td>
                                            <td class="align-middle"><span>{{ order.payment_channel }}</span></td>
                                            <td class="align-middle"><span>{{ order.type }}</span></td>
                                            <td class="align-middle"><span>₦ {{ order.grand_total }}</span></td>
                                            <td class="align-middle">
                                                <div class="d-flex flex-column"><span><i class="fa fa-money"></i>
                                                    {{ order.transaction.status }}
                                                </span> <span><i class="fa fa-car"></i>
                                                    {{ order.status }}
                                                </span></div>
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12 col-md-12">
                    <div class="card active-users">
                        <div class="card-header border-0"><h4 class="card-title">Users</h4></div>
                        <div class="card-content">
                            <div id="audience-list-scroll" class="table-responsive position-relative">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Phone number</th>
                                        <th>Balance</th>
                                        <th>Registered On</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-for="user in users">
                                        <tr>
                                            <td class="text-truncate"><span class="text-truncate">{{ user.first_name }}, {{
                                                    user.last_name
                                                }}</span>
                                            </td>
                                            <td class="align-middle"><span>{{ user.email }}</span></td>
                                            <td class="align-middle"><span>{{ user.phone }}</span></td>
                                            <td class="align-middle"><span>₦ {{ user.balance ?? 0.00 }}</span></td>
                                            <td class="align-middle">
                                                <span class="font-weight-bold text-capitalize">
                                                    {{ user.platform }}
                                                </span>
                                            </td>
                                        </tr>

                                    </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.task-sale-card {
    max-height: 400px;
    overflow-y: auto;
}

.line-height-2-5 {
    line-height: 2.5 !important;
}

.card-controls li {
    display: inline;
}

.green {
    color: #05ec05 !important;
}

.red {
    color: #ff0000 !important;
}

.order-table-title {
    text-decoration: underline;
}
</style>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../Shared/Mixins/PaginationMixin";
import { router } from '@inertiajs/vue2'
import {paymentStatusLabel} from "../Shared/paymentStatus";

export default {
    metaInfo: {title: 'Dashboard'},
    name: 'Dashboard',
    layout: Layout,
    props: [
        'orders',
        'users',
        'total_users',
        'total_revenue',
        'total_stores',
        'total_orders',
        'stores_with_low_inventory',
        'is_store_manager',
        'inactive_stores',
        'url',
    ],
    components: {
        Link,
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
    ],
    data() {
        return {
            fetchedOrders: [],
        };
    },
    mounted() {
        window.Echo.private(`App.Models.Admin.${this.$page.props.auth.user.id}`).notification(async (notification) => {
            console.log("new order came in from event on dashboard");
            await this.fetchOrders();
        });
        this.fetchedOrders = this.orders;
    },
    methods: {
        async fetchOrders() {
            try {
                const response = await axios.get(route('admin.new-orders'));
                this.fetchedOrders = response.data.data.orders;
            } catch (error) {
                console.error('Error fetching orders:', error);
            }
        },
        getPaymentStatus(status) {
            return paymentStatusLabel(status, this.payment_statuses);
        },
    }
}
</script>
